import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import ScrollToTop from "./Component/ScrollToTop";
import Faqs from "./Component/Faqs";
import Cookies from "./Component/Cookies";
import Orders from "./Component/Orders";
import OrderDetail from "./Component/OrderDetail";
import Customers from "./Component/Customers";
import CustomerDetail from "./Component/CustomerDetail";
import Login from "./Component/Login";
import ProtectedRoute from "./Component/ProtectedRoute";
import { AuthProvider } from "./Component/AuthContext";

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/shipping" element={<Delivery />} />
            <Route path="/" element={<Main />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cartpage" element={<CartPage />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/paysuccess" element={<PaySuccess />} />
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/:orderId" element={<OrderDetail />} />
              <Route path="/customers" element={<Customers />} />
              <Route
                path="/customers/:customerId"
                element={<CustomerDetail />}
              />
            </Route>
          </Routes>
          <Footer />
        </AuthProvider>
      </Router>
    </CartProvider>
  );
}

export default App;
